import { useState } from "react";
import Button from "../../Components/Button";
import ReleaseCalculations from "../../Tables/Freeze/ReleaseCalculations/ReleaseCalculations";
import { IFreezeTablesSearchParams } from "../../Interfaces/freeze";
import TabBox from "../../Components/Tabbox/TabBox";
import ReleaseRequests from "../../Tables/Freeze/ReleaseRequests";
import FreezeCalculations from "../../Tables/Freeze/Calculation/FreezeCalculations";
import FreezeRequests from "../../Tables/Freeze/FreezeRequests";
import SearchParamUI from "./SearchParamUI";
import FileDownloader from "../../Components/FileDownloader";
import {
  calculateFreezes,
  calculateReleases,
  getFreezeCalculationsExcel,
  getFreezeReleaseCalculationsExcel,
  getFreezeReleaseRequestsExcel,
  getFreezeRequestsExcel,
  refreshFreezes,
} from "../../Requests/freeze";
import { toast } from "react-toastify";
import { packetErrorHandler } from "../../Utils/requestUtils";

enum ActiveTab {
  ReleaseCalculations,
  ReleaseRequests,
  FreezeCalculations,
  FreezeRequests,
}

const Freeze = () => {
  const [activeTab, setActiveTab] = useState<ActiveTab>(
    ActiveTab.ReleaseCalculations
  );

  const [searchParam, setSearchParam] = useState<IFreezeTablesSearchParams>(
    {} as IFreezeTablesSearchParams
  );

  const tablesTabsChildren = [
    { index: ActiveTab.ReleaseCalculations, title: "محاسبات آزاد کردن فریز" },
    { index: ActiveTab.ReleaseRequests, title: "درخواست های آزاد کردن فریز" },
    { index: ActiveTab.FreezeCalculations, title: "محاسبات فریز" },
    { index: ActiveTab.FreezeRequests, title: "درخواست های فریز" },
  ];

  const calculateFreezeReleaseHandler = () => {
    calculateReleases()
      .then((resp) => {
        if (resp.data) toast.success(resp.msg);
        else toast.error(resp.msg);
      })
      .catch(packetErrorHandler);
  };

  const calculateFreezeHandler = () => {
    calculateFreezes()
      .then((resp) => {
        if (resp.data) toast.success(resp.msg);
        else toast.error(resp.msg);
      })
      .catch(packetErrorHandler);
  };

  const getTable = () => {
    switch (activeTab) {
      case ActiveTab.ReleaseCalculations:
        return <ReleaseCalculations searchParam={searchParam} />;

      case ActiveTab.ReleaseRequests:
        return <ReleaseRequests searchParam={searchParam} />;

      case ActiveTab.FreezeCalculations:
        return <FreezeCalculations searchParam={searchParam} />;

      case ActiveTab.FreezeRequests:
        return <FreezeRequests searchParam={searchParam} />;

      default:
        return <></>;
    }
  };

  const searchParamChangeHandler = (name: string, value: any) => {
    setSearchParam({ ...searchParam, [name]: value });
  };

  const getExcelHandler = () => {
    switch (activeTab) {
      case ActiveTab.ReleaseCalculations:
        return getFreezeReleaseCalculationsExcel(searchParam);
      case ActiveTab.ReleaseRequests:
        return getFreezeReleaseRequestsExcel(searchParam);
      case ActiveTab.FreezeCalculations:
        return getFreezeCalculationsExcel(searchParam);
      case ActiveTab.FreezeRequests:
        return getFreezeRequestsExcel(searchParam);
    }
  };

  const refreshFreezesHandler = () => {
    refreshFreezes(searchParam.accounts)
      .then((resp) => {
        if (resp.data) toast.success(resp.msg);
        else toast.error(resp.msg);
      })
      .catch(packetErrorHandler);
  };

  return (
    <div className="flex flex-col justify-start items-start gap-3 px-5">
      <div className="flex flex-row justify-start items-center gap-10">
        <Button
          text="محاسبه آزاد کردن فریز"
          variant="outlined"
          onClick={calculateFreezeReleaseHandler}
          className="!px-10"
        />
        <Button
          text="محاسبه فریز"
          variant="outlined"
          onClick={calculateFreezeHandler}
        />
      </div>
      <div className="flex flex-row w-full justify-between items-center">
        <div className="max-w-min">
          <TabBox
            activeTab={activeTab}
            children={tablesTabsChildren}
            onChange={(_, index) => setActiveTab(index)}
          />
        </div>
        <div className="flex flex-row justify-start items-center gap-5">
          <SearchParamUI
            onChange={searchParamChangeHandler}
            searchParam={searchParam}
          />
          <div className="w-8 cursor-pointer">
            <FileDownloader getFile={getExcelHandler} />
          </div>
        </div>
      </div>
      <div className="flex flex-row justify-start items-center gap-5 mr-auto">
        <Button
          text="بروزرسانی"
          onClick={refreshFreezesHandler}
          variant="outlined"
          className="!w-min"
        />
      </div>
      {getTable()}
    </div>
  );
};

export default Freeze;
